import { render, staticRenderFns } from "./RoleManage.vue?vue&type=template&id=50faa480&"
import script from "./RoleManage.vue?vue&type=script&lang=js&"
export * from "./RoleManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports